export default "__VITE_ASSET__$_eGcCc2__"